import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CardIngredientsFoods from '../components/CardIngredientsFoods';
import getMeals from '../helpers/ingredientsApi';

export default function FoodIngredientes() {
  const [ingredients, setIngrediets] = useState('');
  const zero = 0;
  const twelve = 12;

  useEffect(() => {
    async function fetchIngredients() {
      const response = await getMeals('listIngredient', '');
      setIngrediets(response.meals);
    }
    fetchIngredients();
  }, [setIngrediets]);

  return (
    <div className="page-wrapper-custom">
      <Header title="Explorar Ingredientes" />
      <Container>
        <div className="recipes-grid-custom mt-4">
          { (ingredients && ingredients.length > zero)
        && ingredients.map((ingredient, index) => {
          if (index < twelve) {
            return (
              <CardIngredientsFoods
                index={ index }
                name={ ingredient.strIngredient }
                key={ index }
                isMeal
              />
            );
          }
          return null;
        })}
        </div>
      </Container>
      <Footer className="footer orange" />
    </div>
  );
}
